import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Users, ChevronRight } from 'lucide-react';
const CART_URL = 'https://omanualproibido.com.br/oferta-especial/?funnel=fn26a5a0d6&step=86&actionId=565400&currentStepId=446780&previousStepId=446768&rda=false&referrer=https%3A%2F%2Fwww.facebook.com%2F';
export function HeroSection() {
  const handleCtaClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Manual de Seducción Prohibida',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center overflow-hidden pt-32 pb-16 px-4 sm:px-6" data-id="element-43">
      {/* Background effects */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-crimson/5 blur-[150px] rounded-full pointer-events-none" data-id="element-44" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-crimson/3 blur-[120px] rounded-full pointer-events-none" data-id="element-45" />
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none" data-id="element-46" />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-47">
        {/* Left: Copy */}
        <div className="flex flex-col space-y-6 z-10 order-2 lg:order-1" data-id="element-48">
          {/* Trust badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-wrap items-center gap-3" data-id="element-49">
            <div className="flex items-center gap-1 bg-white/5 border border-white/10 rounded-full px-3 py-1.5" data-id="element-50">
              <div className="flex" data-id="element-51">
                {[...Array(5)].map((_, i) => <Star key={i} size={12} className="text-yellow-400 fill-yellow-400" data-id="element-52" />)}
              </div>
              <span className="text-xs text-gray-300 ml-1 font-medium" data-id="element-53">
                4.9/5
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3 py-1.5" data-id="element-54">
              <ShieldCheck size={12} className="text-green-400" data-id="element-55" />
              <span className="text-xs text-gray-300 font-medium" data-id="element-56">
                Compra Verificada
              </span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3 py-1.5" data-id="element-57">
              <Users size={12} className="text-crimson-light" data-id="element-58" />
              <span className="text-xs text-gray-300 font-medium" data-id="element-59">
                2,847+ hombres
              </span>
            </div>
          </motion.div>

          {/* Headline */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} data-id="element-60">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black text-white leading-[1.05] tracking-tight" data-id="element-61">
              Cómo conquistar a cualquier mujer en{' '}
              <span className="text-crimson" data-id="element-62">60 segundos</span>
            </h1>
          </motion.div>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.25
        }} className="text-lg sm:text-xl text-gray-300 leading-relaxed max-w-xl" data-id="element-63">
            Descubre el sistema{' '}
            <span className="text-crimson font-semibold" data-id="element-64">prohibido</span> que
            los hombres más atractivos usan para generar atracción instantánea —
            sin frases memorizadas, sin manipulación, sin ser alguien que no
            eres.
          </motion.p>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-start gap-4 pt-2" data-id="element-65">
            <a href={CART_URL} onClick={handleCtaClick} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 bg-crimson hover:bg-crimson-light text-white font-black text-base sm:text-lg py-4 px-8 sm:px-10 rounded transition-all duration-300 shadow-[0_0_30px_rgba(220,38,38,0.3)] hover:shadow-[0_0_40px_rgba(220,38,38,0.5)] uppercase tracking-wider" data-id="element-66">
              ¡Quiero mi copia ahora!
              <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-67" />
            </a>
            <p className="text-xs text-gray-500 self-center" data-id="element-68">
              🔒 Pago 100% seguro · Acceso inmediato
            </p>
          </motion.div>
        </div>

        {/* Right: Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        x: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="relative z-10 flex justify-center order-1 lg:order-2" data-id="element-69">
          <div className="relative w-full max-w-sm sm:max-w-md lg:max-w-lg" data-id="element-70">
            {/* Glow behind image */}
            <div className="absolute inset-0 bg-crimson/15 blur-[60px] rounded-full opacity-50 transform scale-90" data-id="element-71" />
            {/* Discount badge */}
            <div className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 z-20 w-20 h-20 sm:w-24 sm:h-24 bg-crimson rounded-full flex flex-col items-center justify-center shadow-[0_0_30px_rgba(220,38,38,0.5)] border-2 border-white/20" data-id="element-72">
              <span className="text-white font-black text-xl sm:text-2xl leading-none" data-id="element-73">
                70%
              </span>
              <span className="text-white/80 text-[10px] sm:text-xs font-bold uppercase" data-id="element-74">
                OFF
              </span>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/dUCumyGdRDtNLM4eLMGY7t/Generated_Image_February_11,_2026_-_11_47PM.jpg" alt="Manual de Seducción Prohibida" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-white/10" data-id="element-75" />
          </div>
        </motion.div>
      </div>
    </section>;
}